import { useQuery } from 'react-query';

import getStakeLogs, {
  GetStakeLogsInput,
  GetStakeLogsOutput,
} from 'clients/api/queries/getStakeLogs';
import getWithdrawLogs, {
  GetWithdrawLogsInput,
  GetWithdrawLogsOutput,
} from 'clients/api/queries/getWithdrawLogs';
import getRewardLogs, {
  GetRewardLogsInput,
  GetRewardLogsOutput,
} from 'clients/api/queries/getRewardLogs';
import getNetworkRewardLogs, {
  GetNetworkRewardLogsInput,
  GetNetworkRewardLogsOutput,
} from 'clients/api/queries/getNetworkRewardLogs';
import getUserLogs, {
  GetUserLogsInput,
  GetUserLogsOutput,
} from 'clients/api/queries/getUserLogs';
import getRecentLogs, {
  GetRecentLogsInput,
  GetRecentLogsOutput,
} from 'clients/api/queries/getRecentLogs';
import getLogStats, {
  GetLogStatsOutput,
} from 'clients/api/queries/getLogStats';
import { DEFAULT_REFETCH_INTERVAL_MS } from 'constants/defaultRefetchInterval';

// Hook for stake logs
export const useGetStakeLogs = (params: GetStakeLogsInput = {}) =>
  useQuery(
    ['getStakeLogs', params],
    () => getStakeLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  );

// Hook for withdraw logs
export const useGetWithdrawLogs = (params: GetWithdrawLogsInput = {}) =>
  useQuery(
    ['getWithdrawLogs', params],
    () => getWithdrawLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  );

// Hook for reward logs
export const useGetRewardLogs = (params: GetRewardLogsInput = {}) =>
  useQuery(
    ['getRewardLogs', params],
    () => getRewardLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  );

// Hook for network reward logs
export const useGetNetworkRewardLogs = (params: GetNetworkRewardLogsInput = {}) =>
  useQuery(
    ['getNetworkRewardLogs', params],
    () => getNetworkRewardLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  );

// Hook for user logs
export const useGetUserLogs = (params: GetUserLogsInput) =>
  useQuery(
    ['getUserLogs', params],
    () => getUserLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
      enabled: !!params.address,
    },
  );

// Hook for recent logs
export const useGetRecentLogs = (params: GetRecentLogsInput = {}) =>
  useQuery(
    ['getRecentLogs', params],
    () => getRecentLogs(params),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  );

// Hook for log stats
export const useGetLogStats = () =>
  useQuery(
    ['getLogStats'],
    () => getLogStats(),
    {
      refetchInterval: DEFAULT_REFETCH_INTERVAL_MS,
    },
  ); 